import styled from "styled-components"
import getcdn from "~/modules/get_cdn_link"
import Box from "~/components/UI/Box"
import Text from "../UI/Text"
import { useTranslation } from "~/i18n"
import IosButton from "../UI/IosButton"
import GooglePlayButton from "../UI/GooglePlayButton"
import breakpoints from "~/components/UI/breakpoints"

const MyContainer = styled(Box)`
  background: url(${getcdn('images/home/download_bg.jpg')}) no-repeat center;
  height: 400px;
  margin-top: 50px;
  ${breakpoints.md} {
    height: 490px;
  }
`

const Download = () => {
  const [t] = useTranslation()
  return (
    <MyContainer padding='0 20px' flex mdStyle={{ alignItems: 'center' }} justify='center' column>
      <Text color='#fff' mdSize={36} lgSize={48} size={24}>
        {t('Tải App để trải nghiệm Infina ngay!')}
      </Text>
      <Text margin='32px 0' color='#fff' mdSize={24} size={18}>
        {t('Rất nhiều ưu đãi hấp dẫn dành cho bạn sau khi tải App!')}
      </Text>
      <Box height='auto' flex>
        <IosButton style={{ marginRight: 20 }} />
        <GooglePlayButton />
      </Box>
    </MyContainer>
  )
}

export default Download
